export default () => {
  return {
    id: '',
    profile: {},
    role: '',
  }
}
